import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import FormatWatermark from '../common/FormatWatermark'

type Common = {
  title?: string
  subtitle?: string
  image?: string | null
  href?: string
  badge?: string | null
  meta?: string | null
  price?: string | null
  watermarkFormat?: string | null
  watermarkCategory?: string | null
  watermarkLabel?: string | null
}

export function PixeCard({
  title,
  subtitle,
  image,
  href = '#',
  badge = null,
  meta = null,
  price = null,
  watermarkFormat = null,
  watermarkCategory = null,
  watermarkLabel = null,
}: Common) {
  const [loaded, setLoaded] = useState(false)
  const badgeClass =
    badge === 'Free'
      ? 'bg-white/10 text-white/70 border border-white/15'
      : 'bg-black/65 text-white shadow'
  const badgePositionClass = `${watermarkFormat ? 'top-12' : 'top-2'} ${price ? 'left-2' : 'right-2'}`
  return (
    <Link to={href} className="group relative rounded-xl overflow-hidden block hover:shadow-lg hover:shadow-black/30 transition-transform duration-200 ease-out will-change-transform hover:scale-[1.015]">
      <div className="aspect-[8/9] bg-white/5">
        {image ? (
          <img
            src={image}
            alt={title || 'Pixe'}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            className={`h-full w-full object-cover transition-all duration-500 ${loaded ? 'opacity-100 blur-0 scale-100' : 'opacity-80 blur-sm scale-[1.02]'}`}
          />
        ) : null}
      </div>
      <FormatWatermark
        format={watermarkFormat}
        category={watermarkCategory}
        labelOverride={watermarkLabel}
        className="absolute left-3 top-3"
      />
      {badge ? (
        <span className={`absolute ${badgePositionClass} rounded-full px-2 py-0.5 text-[10px] font-semibold tracking-wide ${badgeClass}`}>
          {badge}
        </span>
      ) : null}
      {price ? (
        <span className="absolute right-2 top-2 rounded-full bg-black/70 px-2 py-0.5 text-[11px] font-semibold text-white shadow">
          {price}
        </span>
      ) : null}
      {(title || subtitle || meta) && (
        <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/60 via-black/20 to-transparent">
          {!!title && <div className="text-sm font-semibold text-white line-clamp-1">{title}</div>}
          {!!subtitle && <div className="text-xs text-white/85 line-clamp-1">{subtitle}</div>}
          {!!meta && <div className="text-[11px] text-white/75 line-clamp-1">{meta}</div>}
        </div>
      )}
    </Link>
  )
}
